"use client";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AboutHeroSection from "@/components/AboutHeroSection";
import aiml from "../../public/assets/images/services/ai-ml/ai-ml.png";
import Image from "next/image";
import {
  aimlServices,
  aimlTechnologies,
  aimlTimeLine,
  cloudServices,
  cloudTechnologies,
  cloudTimeLine,
} from "../../utils/libs/utils";
const ServiceBox = ({ title, description, points }) => (
  <div className="service-inner-box w-100 ">
    <h3>{title}</h3>
    <p>{description}</p>
    {points && (
      <ul>
        {points.map((point, index) => (
          <li key={index}>{point}</li>
        ))}
      </ul>
    )}
  </div>
);

const AIML = () => {
  useEffect(() => {
    const reveal = () => {
      document.querySelectorAll(".reveal").forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        const elementVisible = 10;

        if (
          elementTop < windowHeight - elementVisible &&
          !el.classList.contains("active")
        ) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal(); // run on load

    return () => window.removeEventListener("scroll", reveal);
  }, []);

  return (
    <div>
      <AboutHeroSection
        pillText="~ Our Tech Stack ~"
        title="AI/ML Development with"
        highlight="Neoverce"
        description="Our elite AI engineers craft tailored solutions leveraging deep learning, neural networks, computer vision and NLP. From predictive analytics to machine learning algorithms, our solutions optimize operations and revolutionize your business strategy."
        imageAlt="AI/ML Development"
        image={aiml}
      />
      <div className="py-5">
        <Container>
          <Row className="justify-content-center gy-4">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Revolutionize Your Business with Smart{" "}
                <span>AI & ML Solutions</span>
              </h3>
              <p className="reveal fade-bottom">
                At Neoverce, we’re committed to helping businesses thrive in the
                age of AI. Our suite of AI/ML Development Services is designed
                to address your unique challenges, deliver transformative
                results, and seamlessly embedding intelligent systems into your
                business processes to transform operations, enhance
                decision-making, and elevate customer experiences.
              </p>
            </Col>

            {aimlServices.map((service, idx) => (
              <Col
                md={6}
                sm={12}
                key={idx}
                className="d-flex reveal fade-bottom"
              >
                <ServiceBox {...service} />
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="service-section-bg my-5">
        <Container>
          <Row className="gy-4 justify-content-center">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Leading Tools Powering <span>Our AI/ML Solutions</span>
              </h3>
              <p className="reveal fade-bottom">
                We utilize advanced AI/ML frameworks like TensorFlow, PyTorch,
                and Scikit-learn to build intelligent, data-driven solutions.
                Our expertise spans across model training, deployment, and
                optimization—empowering businesses with automation, prediction,
                and real-time insights.
              </p>
            </Col>

            {aimlTechnologies.map((tech, index) => (
              <Col
                key={index}
                lg={2}
                md={3}
                sm={4}
                xs={6}
                className="reveal fade-bottom d-flex"
              >
                <div className="tech-image-box text-center">
                  <Image
                    height={100}
                    width={100}
                    alt={tech.alt}
                    src={tech.src}
                    className="img-fluid"
                  />
                  <h3>{tech.name}</h3>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="mt-5 py-5">
        <Container>
          <Row>
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                360-Degree Implementation <span>Strategy</span>
              </h3>
              <p className="reveal fade-bottom">
                We follow stringent methodologies for AI/ML services including
                in-depth requirement analysis, model training, and deployment.
                We conduct domain workshops for problem definition, optimize
                models with tuning, and ensure accuracy with continuous
                monitoring and retraining.
              </p>
            </Col>
          </Row>
          <div className="py-5">
            <Row className="timeline zipzap gx-0 position-relative">
              {aimlTimeLine.map((step, i) => {
                const isFirst = i === 0;
                const isLast = i === aimlTimeLine.length - 1;

                const timelineRowClass =
                  `timeline-row d-flex align-items-center pb-5 position-relative
            ${isFirst ? "first-timeline" : ""}
            ${isLast ? "last-timeline" : ""}
          `.trim();

                return (
                  <Col key={i} md={12} className={timelineRowClass}>
                    {i % 2 === 0 ? (
                      <>
                        <Col
                          md={6}
                          className="d-flex justify-content-center even-section align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="timeline-box text-box ms-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={6} className="text-md-end">
                          <div className="timeline-box text-box me-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                        <Col
                          md={6}
                          className="d-flex justify-content-center align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                  </Col>
                );
              })}
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default AIML;
